import navigation from '../../public/locales/en/navigation.json'
import LocalizedLink from '@components/Localization/LocalizedLink'
import { Icon } from '@components/gassan-ui'
import { useTranslation } from 'next-i18next'
import { FC } from 'react'

type BreadcrumbsProps = {
  items: (keyof typeof navigation.rcpo)[]
  currentPageTitle: string
}

export const Breadcrumbs: FC<BreadcrumbsProps> = ({ items, currentPageTitle }) => {
  const { t } = useTranslation('navigation')
  return (
    <div className="mx-auto flex h-6 w-full max-w-[1680px] items-center gap-1 bg-white px-5">
      {items.map((item, index) => (
        <div key={index} className="hidden items-center gap-1 md:flex">
          <LocalizedLink href={t(`rcpo.${item}.url`)}>
            <a className="text-xs text-rolexShade-900 transition-colors duration-150 hover:text-rolexPrimary">
              {t(`rcpo.${item}.title`)}
            </a>
          </LocalizedLink>
          <Icon icon="chevron-right" size={16} />
        </div>
      ))}
      <span className="hidden text-xs text-rolexShade-900 md:block">{currentPageTitle}</span>
      {items.length && (
        <div className="flex items-center gap-1 md:hidden">
          <LocalizedLink href={t(`rcpo.${items[items.length - 1]}.url`)}>
            <a className="flex items-center gap-1">
              <Icon icon="chevron-left" size={16} />
              <span className="text-xs text-rolexShade-900">{currentPageTitle}</span>
            </a>
          </LocalizedLink>
        </div>
      )}
    </div>
  )
}
